var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ams-ad is-flex is-justify-content-center is-clipped",attrs:{"id":"camptocamp_htad"}})
}
var staticRenderFns = []

export { render, staticRenderFns }